module.exports = __webpack_public_path__ + "static/media/dash-photos-icon.323faf94.svg";